<div class="row">

    <div class="col-sm-12">
    The Boldungu  Project   is intended to improve the performance of learners in math. We also aim to provide resources for teachers and parents to support learners.
    We would like to offer this service 100% free, but we are constrained by the costs involved. For this reason, we have 50% of the content free forever.
    The little charge for full access is intended to support the Project. So we have, Full Access and Partial Access.


    </div>
    </div>
    <div class="row"  id="service-pricing">

    <div class="col-sm-6">
    <div class="jumbotron">
 <h3 class="text-primary text-center">Free Lifetime Access to 50% of  Material</h3>

 Offers all capabilities for selected themes, topics and subtopics for a given level or grade.
 <table class="table table-compressed table-striped">
 <tr><td rowspan="4"> <img src="/assets/images/orange_half.png" width="200px"></td><td>Topics and subtopics</td><td>50%</td></tr>
 <tr><td>Marking</td><td><i class="fa fa-check"></i></td></tr>
 <tr><td>Grading</td><td><i class="fa fa-check"></i></td></tr>
 <tr><td>Guardian can generate quiz</td><td><i class="fa fa-check"></i></td></tr>
 </table>
<div class="text-center"> <span class="price-amount"><strong>FREE LIFETIME ACCESS</strong></span></div>
<div class="text-center">
         <a routerLink="/user/new/step/one"  class="w-100 btn btn-primary green-bg-btton-nav"> Join Now</a>
       </div>
</div>

 </div>
    <div class="col-sm-6">
    <div class="jumbotron">
<h3 class="text-primary text-center"> Full Access </h3>

<div class="text-center"> means full, gives you access to all we have.</div>

 <table class="table table-compressed table-striped">
 <tr>
  <td class="text-center">
  <img src="/assets/images/orange_full.png" width="200px">
  </td>
  </tr>

 </table>
 <div class="text-center"> <span class="price-amount"><strong>FULL ACCESS</strong></span></div>
 <div class="text-center">
  <a routerLink="/user/new/step/one"  class="w-100 btn btn-primary green-bg-btton-nav"> Join Now</a>
</div>


</div>
</div>

 </div>
 <div class="row">
  <div class="table-responsive col-sm-12" *ngIf="billingRates.length>0" >
    <h6 class="text-center"> Full Access  for Weekly, Monthly or Year</h6>
    <table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
        <thead>
        <tr>
        <th>Country</th>
        <th>Currency</th>
        <th>Week</th>
        <th>Month</th>
        <th>Year</th>


        </tr>
        </thead>

        <tbody>

        <tr *ngFor="let bRate of billingRates;">
          <td>
            <app-country-flag *ngIf="bRate" [countryImage]="bRate.countryImage"></app-country-flag>
            {{bRate.name}}

            </td>
            <td>
              {{bRate.currency }}
              </td>
            <td>
            {{bRate.week.week | currency: bRate.currency+' ':'symbol':'4.0'}}
            </td>
            <td>
              {{bRate.month.month | currency: bRate.currency+' ':'symbol':'4.0'}}
            </td>
            <td>
              {{bRate.year.year | currency: bRate.currency+' ':'symbol':'4.0'}}
            </td>
        </tr>

        </tbody>

    </table>
    </div>

 </div>
 <app-country-level-syllabus></app-country-level-syllabus>

